module.exports = __webpack_public_path__ + "static/media/pipe2_up.7ab5a22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/pipe2_up.png
// module id = 244
// module chunks = 0